
  import { Vue, Component, Prop } from "vue-property-decorator";
  import S3Image from "@/components/common/s3-image.vue";
  import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
  import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";

  @Component({
    components: {
      S3Image,
      CircleWithInitials,
      SchedulerItemAvatar,
    }
  })
  export default class EmployeeGroup extends Vue {
    @Prop({ type: Object, default: () => ({}) }) readonly employeeItem!: {name: string, avatar: string};
    @Prop({ type: Boolean, default: false }) readonly managerRole!: boolean;

    get name(): string {
      return this.employeeItem.name;
    }

    get avatar(): string {
      return this.employeeItem.avatar;
    }

  }
